import { type GetMultipartPartResponse } from '@air/api/types';
import { type UploadUrlType } from '@air/redux-uploader';

import { isStatus0Error } from './uploadErrors';

type UploadUrlInfoWithFallback = Pick<GetMultipartPartResponse, 'url' | 'fallbackUrl'>;

type GetUploadUrlForRetryParams = {
  currentUrl: string;
  error: unknown;
  uploadUrlInfo: UploadUrlInfoWithFallback;
};

export const getUploadUrlForRetry = ({ currentUrl, error, uploadUrlInfo }: GetUploadUrlForRetryParams): string => {
  if (currentUrl === uploadUrlInfo.url && uploadUrlInfo.fallbackUrl && isStatus0Error(error)) {
    return uploadUrlInfo.fallbackUrl;
  }

  return currentUrl;
};

export const getUploadUrlType = ({
  currentUrl,
  uploadUrlInfo,
}: Pick<GetUploadUrlForRetryParams, 'currentUrl' | 'uploadUrlInfo'>): UploadUrlType =>
  currentUrl === uploadUrlInfo.fallbackUrl ? 'fallback' : 'primary';
